module.exports = __webpack_public_path__ + "static/media/supported.c42c0ff1.mp3";